import React, { useState } from "react";
import "./tooltip.scss";
import { falseDependencies } from "mathjs";

const Tooltip = ({ infoText, noArrow = false, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >

      {!noArrow && <div className={`arrow-down ${showTooltip ? "open" : ""}`} />}
      <div className={`tooltip ${showTooltip ? "open" : ""}`}>
      <span className="text">
        {infoText}
      </span>
      </div>
      {children}
    </div>
  );
};

export default Tooltip;